import React from "react";

const FurnishingStatus = ({
  selectedFurnished = [],
  handleFurnishedPress,
}) => {
  const furnishingStatus = [
    { id: "1", name: "Furnished" },
    { id: "2", name: "Semi Furnished" },
    { id: "3", name: "Un Furnished" },
  ];

  return (
    <div className="mainbarfiltercomponents">
      {furnishingStatus.map((furnish, index) => {
        const isChecked = selectedFurnished.some(
          (f) => f.toLowerCase() === furnish.name.toLowerCase()
        );
        return (
          <div
            className="propertyboxes"
            key={index}
            onClick={() =>
              handleFurnishedPress && handleFurnishedPress(furnish.name)
            }
            style={{ cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {}}
              style={{ cursor: "pointer" }}
            />
            <p className="propertytextpara" style={{ margin: 0, paddingLeft: "8px" }}>
              {furnish.name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default FurnishingStatus;